import { Component, inject, Input } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatCheckbox } from '@angular/material/checkbox'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'

import { MatButtonModule } from '@angular/material/button'
import { CustomSymbologyComponent } from '@components/custom-symbology/custom-symbology.component'
import { ExportDataService } from '@components/panel/tabs/results-tab/result-manager/export-data/export-data.service'
import { ScenarioService } from '@components/panel/tabs/scenario-tab/scenario.service'
import { ScenarioExplorerResult } from '@core/models/scenario-tab.model'

@Component({
  selector: 'app-card-layer-scenario',
  standalone: true,
  imports: [
    // Component
    CustomSymbologyComponent,
    // Material
    MatCheckbox,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatTooltipModule,
  ],
  templateUrl: './card-layer-scenario.component.html',
})
export class CardLayerScenarioComponent {
  @Input({ required: true }) result!: ScenarioExplorerResult

  private readonly _scenarioService = inject(ScenarioService)
  private readonly _exportDataService = inject(ExportDataService)

  selectScenarioResult(value: boolean) {
    if (value === true) {
      this._scenarioService.addLayer(this.result)
    } else {
      this._scenarioService.removeLayer(this.result)
    }
  }

  exportIAMCCSV() {
    if (!this.result.dataframe?.length) {
      return
    }
    return this._exportDataService.dataToCsv(
      this.result.dataframe,
      this.result.payload.model,
      false,
      Object.keys(this.result.dataframe[0]),
    )
  }
}
